import React from 'react';

import FleetbackLoader from 'ui/base/FleetbackSplash';

const LazyLoader = ({ children }) => (
  <React.Suspense fallback={<FleetbackLoader />}>
    {children}
  </React.Suspense>
);

export default LazyLoader;
